import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject } from "../shared";
const GANN_ANGLES = [
    { label: "1x1", slope: 1 },
    { label: "1x2", slope: 0.5 },
    { label: "2x1", slope: 2 },
    { label: "1x3", slope: 1 / 3 },
    { label: "3x1", slope: 3 },
    { label: "1x4", slope: 0.25 },
    { label: "4x1", slope: 4 },
    { label: "1x8", slope: 0.125 },
    { label: "8x1", slope: 8 },
];
export function calculateGannFixedGeometry(drawing, scales) {
    const [pivotPoint] = drawing.points;
    if (!pivotPoint)
        return null;
    const pivot = chartPointToPixel(pivotPoint, scales);
    const extend = 10000;
    const lines = GANN_ANGLES.map(({ label, slope }) => {
        // For Gann, slope is price/time ratio
        // In pixel space: dy/dx = slope * (priceScale / timeScale)
        const pricePerTime = slope;
        const angle = Math.atan(pricePerTime);
        const dx = extend * Math.cos(angle);
        const dy = extend * Math.sin(angle);
        return {
            angle: label,
            start: pivot,
            end: { x: pivot.x + dx, y: pivot.y - dy }, // y inverted in canvas
        };
    });
    return { pivot, lines };
}
const GannFixed = {
    name: "gannFixed",
    createDraft: (startPoint) => createDrawingObject("gannFixed", [startPoint]),
    updateDraft: (draft, nextPoint) => ({
        ...draft,
        points: [nextPoint], // Single pivot point
    }),
    render: () => undefined,
};
export default GannFixed;
